import { cn } from "@/lib/utils";
import { Bot, User, FileSpreadsheet, Settings2 } from "lucide-react";
import { useTranslation } from "react-i18next";
import { MessageContent } from "./MessageContent";
import type { ChatMessage } from "./MessageList";

interface MessageBubbleProps {
  message: ChatMessage;
}

export function MessageBubble({ message }: MessageBubbleProps) {
  const { t } = useTranslation("common");
  const isUser = message.role === "user";
  // Use fileName from server, or file.name for new uploads
  const fileName = message.fileName || message.file?.name;

  return (
    <div className={cn("flex gap-3", isUser && "flex-row-reverse")}>
      <div
        className={cn(
          "shrink-0 w-7 h-7 rounded-full flex items-center justify-center",
          isUser ? "bg-neutral-800 text-white" : "bg-neutral-100 text-neutral-600"
        )}
      >
        {isUser ? <User className="h-4 w-4" /> : <Bot className="h-4 w-4" />}
      </div>
      <div
        className={cn(
          "max-w-[85%] rounded-lg px-3 py-2 text-sm",
          isUser ? "bg-neutral-800 text-white" : "bg-neutral-100 text-neutral-800"
        )}
      >
        {fileName && (
          <div
            className={cn(
              "flex items-center gap-2 mb-2 text-xs px-2 py-1.5 rounded-lg w-fit",
              isUser ? "bg-neutral-700/50" : "bg-neutral-200"
            )}
          >
            <FileSpreadsheet className="w-4 h-4 opacity-70" />
            <span className="opacity-80">{fileName}</span>
          </div>
        )}
        <MessageContent content={message.content} />
        {!isUser && message.delegateUsed && (
          <div className="mt-1.5">
            <span
              className="inline-flex items-center gap-1 text-xs text-neutral-400 bg-neutral-200/60 rounded-sm px-1.5 py-0.5"
            >
              <Settings2 className="h-3 w-3 shrink-0" />
              <span>{t("chat.delegation.analyzed")}</span>
            </span>
          </div>
        )}
      </div>
    </div>
  );
}
